"use client";

import { useZStore } from "@/utils/z-store";

/**
 * Remounts the dashboard content subtree whenever the ACTIVE workspace changes,
 * so every page's data-loading effects re-run under the new `x-workspace-id`
 * header — a clean, reload-free refetch on switch.
 *
 * Route navigation between pages keeps the same key, so this remounts ONLY on an
 * actual workspace switch. (There is also one settle on the initial localStorage
 * rehydration, because the active workspace isn't known at SSR time — harmless:
 * the server resolves the workspace from `lastActiveWorkspaceId` even before the
 * header is set.)
 */
export default function WorkspaceBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data } = useZStore();
  return (
    <div key={data.activeWorkspaceId ?? "no-workspace"} className="h-full">
      {children}
    </div>
  );
}
